function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stableStringify } from "@sail/utils";
class ObservableData {
    notifyObservers(result) {
        this.observers.forEach(function triggerObserverNext(observer) {
            observer.next(result);
        });
    }
    notifyObserversWithCurrentResult() {
        var _this_latestResult, _this_latestResult1;
        this.notifyObservers({
            data: ((_this_latestResult = this.latestResult) === null || _this_latestResult === void 0 ? void 0 : _this_latestResult.data) || null,
            errors: ((_this_latestResult1 = this.latestResult) === null || _this_latestResult1 === void 0 ? void 0 : _this_latestResult1.errors) || null
        });
    }
    watch() {
        return this.resultStore.watchResults(this.query, this.variables, (results)=>{
            this.notifyObservers(results);
        });
    }
    setIsPending(isPending) {
        var _this_latestResult;
        if (((_this_latestResult = this.latestResult) === null || _this_latestResult === void 0 ? void 0 : _this_latestResult.isPending) !== isPending) {
            this.latestResult = this.latestResult ? {
                data: this.latestResult.data,
                errors: this.latestResult.errors,
                isPending
            } : {
                data: null,
                errors: null,
                isPending
            };
            this.notifyObserversWithCurrentResult();
        }
    }
    getCurrentResult() {
        var _this_latestResult, _this_latestResult1;
        const newResult = this.resultStore.getCurrentResult(this.query, this.variables);
        // Adapt the value for new results from the result store
        if (stableStringify((_this_latestResult = this.latestResult) === null || _this_latestResult === void 0 ? void 0 : _this_latestResult.data) !== stableStringify(newResult.data) || stableStringify((_this_latestResult1 = this.latestResult) === null || _this_latestResult1 === void 0 ? void 0 : _this_latestResult1.errors) !== stableStringify(newResult.errors)) {
            var _this_latestResult2;
            this.latestResult = {
                data: newResult.data,
                errors: newResult.errors,
                isPending: ((_this_latestResult2 = this.latestResult) === null || _this_latestResult2 === void 0 ? void 0 : _this_latestResult2.isPending) || false
            };
        }
        // Return a stable reference if the results haven't changed.
        return this.latestResult;
    }
    isActive() {
        return this.observers.size > 0;
    }
    constructor(query, variables, resultStore){
        // Document node that will be used to check apollo cache for data.
        _define_property(this, "query", void 0);
        // Variables given to the useQuery hook, used to check apollo cache for data.
        _define_property(this, "variables", void 0);
        // List of observers for this particular document + variables combination.
        _define_property(this, "observers", new Set());
        _define_property(this, "resultStore", void 0);
        _define_property(this, "latestResult", {
            data: null,
            errors: null,
            isPending: false
        });
        this.query = query;
        this.variables = variables;
        this.resultStore = resultStore;
    }
}
export { ObservableData as default };

//# sourceMappingURL=ObservableData.js.map